module.exports = __webpack_public_path__ + "img/bulle-etudiant.dc47af1.png";